import { WindowLocation } from './window-location';

export const removeUrlSearchParam = (paramName: string) => {
    const url = new URL(WindowLocation.getHref());
    url.searchParams.delete(paramName);
    history.replaceState({}, '', url.href);
};
